import type { BackfillAuditNormLine } from '@/services/cloverBackfillAudit'

function formatNormLine(line: BackfillAuditNormLine): string {
  const parts = [
    line.account_name ?? line.account_id,
    line.department_name,
    line.entity_name,
    line.posting_type,
    line.amount != null ? String(line.amount) : null,
    line.description,
  ].filter(Boolean)
  return parts.join(' · ')
}

type Props = {
  beforeLines: BackfillAuditNormLine[]
  afterLines: BackfillAuditNormLine[]
  beforeTitle?: string
  afterTitle?: string
  changedKeys?: Set<string>
}

export default function BackfillAuditLineComparison({
  beforeLines,
  afterLines,
  beforeTitle = 'Before (QBO)',
  afterTitle = 'After (rebuilt)',
  changedKeys,
}: Props) {
  const highlight = changedKeys ?? new Set<string>()

  return (
    <div className="grid gap-4 md:grid-cols-2">
      <div>
        <h4 className="mb-2 text-sm font-semibold text-gray-900">{beforeTitle}</h4>
        <ul className="space-y-1 text-xs text-gray-700">
          {beforeLines.map((line, index) => (
            <li
              key={`before-${index}`}
              className={highlight.has(line.account_name ?? '') ? 'font-medium text-amber-900' : ''}
            >
              {formatNormLine(line)}
            </li>
          ))}
          {beforeLines.length === 0 ? <li className="text-gray-500">—</li> : null}
        </ul>
      </div>
      <div>
        <h4 className="mb-2 text-sm font-semibold text-gray-900">{afterTitle}</h4>
        <ul className="space-y-1 text-xs text-gray-700">
          {afterLines.map((line, index) => (
            <li
              key={`after-${index}`}
              className={highlight.has(line.account_name ?? '') ? 'font-medium text-amber-900' : ''}
            >
              {formatNormLine(line)}
            </li>
          ))}
          {afterLines.length === 0 ? <li className="text-gray-500">—</li> : null}
        </ul>
      </div>
    </div>
  )
}
